import {useEffect, useRef} from 'react';
import usePrevious from './usePrevious';

export default function useEffectOnChange(callback: Function, value: any) {
  const prev = usePrevious(value);
  const mountedRef = useRef(false);
  useEffect(() => {
    const mounted = mountedRef.current;
    mountedRef.current = true;
    if (mounted && prev !== value) {
      return callback();
    }
    /**
     * prev, callback도 deps에 넣는 게 우리 컨벤션에 맞지만,
     * 그렇게 하려면 코드가 복잡해지므로 테스트 코드를 믿고 넣지 않았다
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
}
